import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { PaymentProtectionFeatureConfig } from '../../../types/insurances/PaymentProtectionFeatureConfig';
import { paymentProtection as base } from './base';
import { paymentProtection as RO } from './RO';

export const paymentProtectionConfig: InsuranceIndex<PaymentProtectionFeatureConfig> = { base, RO };
